module.exports = __webpack_public_path__ + "assets/img/ja-d32aec11.png";